import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import {EditOutlined} from '@ant-design/icons';

const CustomerUpdateForm = ({ visible, onCreate, onCancel, record }) => {

  const [form] = Form.useForm();
  let customer =record
  const [customerID]=useState(customer.CustomerID)
  const [customerName]=useState(customer.CustomerName)
  const [customerAddress]=useState(customer.CustomerAddress)
  const [customerEmail]=useState(customer.CustomerEmail)
  const [customerPhone]=useState(customer.CustomerPhone)

  return (
    <Modal
      visible={visible}
      title="Update Customer"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="CustomerUpdate"
        initialValues={{
            CustomerID:customerID,
            CustomerName:customerName,
            CustomerAddress:customerAddress,
            CustomerEmail:customerEmail,
            CustomerPhone:customerPhone,
        }}
      >
        <Form.Item
          name="CustomerID"
          label="Customer ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item
          name="CustomerName"
          label="Customer Name"
        >
          <Input />
        </Form.Item>
        <Form.Item name="CustomerAddress" label="Customer Address">
          <Input />
        </Form.Item>
        <Form.Item 
            name='CustomerEmail' label="Customer Email"           
            rules={[
            {type: 'email',message: 'The input is not valid E-mail!',},
            { required: false, message: 'Please input your Email!' }]}
          >
            <Input />
        </Form.Item>
        <Form.Item 
        name='CustomerPhone' label="Customer Phone"
        validateTrigger='onBlur'
          rules={[
            {
              required:false,
              pattern: new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "g"),
              message:'Please enter the correct format'
            }
          ]}>
            <Input addonBefore={'+1'}/>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const CustomerUpdate = (props) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.updateCustomer(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
        
      </Button>
      <CustomerUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default CustomerUpdate